<template>
    <b-button v-if="!$store.state.isLoggedIn" :variant="variant" @click="$store.commit('openRegistrationModal');">
        {{ text }}
    </b-button>
</template>

<script setup lang="ts">
import { BaseButtonVariant } from 'bootstrap-vue-next';

withDefaults(defineProps<{
    text?: string,
    variant?: keyof BaseButtonVariant,
}>(), {
    text: 'Registrace',
    variant: 'primary',
});

</script>
